import { Column, Row, Txt } from '@stenajs-webui/core';
import { FlatButton } from '@stenajs-webui/elements';
import type { FC, MouseEvent } from 'react';
import type { BasicBooking } from '../../../../common/graphql/fragments/gql/BasicBooking';
import type { SearchResultColumn } from '../utils/searchResultColumns';
import { BookingSearchTableRow } from './BookingSearchTableRow';

export interface BookingSearchTableProps {
  items: BasicBooking[];
  label: string;
  linkClassName?: string;
  onClickResult: (bookingNo: number) => void;
  onTotalCountClick: (e: MouseEvent<HTMLElement>) => void;
  searchColumns: SearchResultColumn[];
  searchQuery: string;
  totalCount: number;
}

export const BookingSearchTable: FC<BookingSearchTableProps> = ({
  onClickResult,
  linkClassName,
  items,
  label,
  onTotalCountClick,
  totalCount,
  searchQuery,
  searchColumns,
}) => (
  <Column>
    <Row alignItems={'center'} indent={2} justifyContent={'space-between'} spacing>
      <Txt size={'small'} variant={'overline'}>
        {label}
      </Txt>

      <FlatButton
        className={linkClassName}
        onClick={onTotalCountClick}
        size={'small'}
        label={`Show all (${totalCount})`}
      />
    </Row>

    {items.map(item => (
      <BookingSearchTableRow
        onClickResult={() => onClickResult(item.bookingNo)}
        item={item}
        key={item.bookingNo}
        searchColumns={searchColumns}
        searchQuery={searchQuery}
      />
    ))}
  </Column>
);
